<!-- Header Template Included - Starts -->
<app-header></app-header>

<section class="mar-top-30">
  <ul class="nav nav-tabs" id="partTab" role="tablist">
    <li  class="nav-item">
        <a class="nav-link {{istabActive ? istabActive[0] : ''}}" (click)="onTabClick(0)" routerLink="./partsInfo/{{packageID}}"  routerLinkActive="active" id="partInfoTab">{{'PARTINFORMATION' | translate}}</a>
    </li>
    <li  class="nav-item" >
        <a class="nav-link {{istabActive ? istabActive[1] : ''}}" (click)="onTabClick(1)" routerLink="./supplyInfo/{{packageID}}" routerLinkActive="active" id="supplyInfoTab">{{'SUPPLIER&SUPPLYINFO' | translate}}</a>
    </li>
    <li  class="nav-item" >
        <a class="nav-link {{istabActive ? istabActive[2] : ''}}" (click)="onTabClick(2)" routerLink="./packageInfo/{{packageID}}" routerLinkActive="active" id="packageInfoTab">{{'PACKAGEINFOPAGE' |translate}}</a>
    </li>
  </ul>
</section>
 <router-outlet></router-outlet>


<ng-template #content let-c="close" let-d="dismiss">
    <!-- <div class="modal-header">
      <h4 class="modal-title">Modal title</h4>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div> -->
    <div class="modal-body">
      <p>You have unsaved changes. Do you want to leave this page and lose your changes?</p>
      <p>Click <b>Save</b> button to save your data or <b>Cancel</b> to navigate.</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-dark" (click)="saveBefore()">Save</button>
      <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">Cancel</button>
    </div>
  </ng-template>